import * as React from "react";
const SvgEye = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="33 31 18 22"
    fill="none"
    {...props}
  >

    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    >
      <path d="M44.121 44.121a3 3 0 1 0-4.242-4.242 3 3 0 0 0 4.242 4.242" />
      <path d="M32.458 42c1.274-4.057 5.065-7 9.542-7 4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7s-8.268-2.943-9.542-7" />
    </g>
  </svg>
);
export default SvgEye;
